import styled, { css } from 'styled-components';
export var WaveformContainer = styled.div.withConfig({
  displayName: "Waveformstyles__WaveformContainer",
  componentId: "sc-178jagn-0"
})(["display:grid;grid-template-areas:'container';grid-template-columns:1fr;height:2.5rem;overflow:hidden;position:relative;max-width:100%;"]);
export var Slider = styled.input.withConfig({
  displayName: "Waveformstyles__Slider",
  componentId: "sc-178jagn-1"
})(["cursor:pointer;appearance:none;grid-area:container;width:100%;height:inherit;z-index:", ";&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:0;height:0;}&::-moz-range-thumb{width:0;height:0;border:none;}"], function (props) {
  return props.theme.zIndexes.above;
});
export var Waveform = styled.div.withConfig({
  displayName: "Waveformstyles__Waveform",
  componentId: "sc-178jagn-2"
})(["grid-area:container;grid-template-areas:'waveform';display:none;grid-template-columns:1fr;height:inherit;width:100%;max-width:100%;overflow:hidden;", "{display:grid;}", ""], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.willClip && css(["clip-path:inset(0 100% 0 0);"]);
});